export default "__VITE_ASSET__BvW68nR4__"